import { render, staticRenderFns } from "./EmailThread.vue?vue&type=template&id=27bd4f72&"
import script from "./EmailThread.vue?vue&type=script&lang=js&"
export * from "./EmailThread.vue?vue&type=script&lang=js&"
import style0 from "./EmailThread.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports